"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var components_1 = require("stremio/components");
var Link_less_1 = __importDefault(require("./Link.less"));
var Link = function (_a) {
    var label = _a.label, href = _a.href, target = _a.target, onClick = _a.onClick;
    return (react_1.default.createElement(components_1.Button, { className: Link_less_1.default['link'], title: label, target: target !== null && target !== void 0 ? target : '_blank', href: href, onClick: onClick },
        react_1.default.createElement("div", { className: Link_less_1.default['label'] }, label)));
};
exports.default = Link;
